import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';

import TeamMappingForm from './TeamMappingForm';
import LoadingPageText from '../../../common/Loading/LoadingPageText';

import { useTeamMappings } from '../../../../actions/areas/admin/fetchHooks/fetchExternalProvider';
import { tableSettings } from './teamMappingTableSettings';
import { eventHandlers } from './../externalProviderHandler';

export default function TeamMappingContent({ mappingType }) {
  const [state, setState] = useState({
    forceReload: false,
    currentPage: 1,
    pageSize: 15,
    openSidePanel: false,
    sortColumn: 'DateCreated',
    sortDirection: 'desc',
    selectedRow: {},
    errorMsg: null,
    isDataLoading: false,
  });

  const model = {
    mappingType,
    pageSize: state.pageSize,
    currentPage: state.currentPage,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
  };
  const { data, isDataLoading, auth, isTableDataLoading } = useTeamMappings(model, state.forceReload);

  const events = eventHandlers(state, setState, auth);
  document.title = events.locale.getMsg('providerTeamMapping');

  const settings = tableSettings({
    mappingType,
    count: data.totalCount,
    page: data.currentPage - 1,
    pageSize: data.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    eventHandlers: events,
    isTableDataLoading,
  });

  if (isDataLoading)
    return <LoadingPageText showHeader={false}>{events.locale.getMsg('loadingMsg', [document.title])}</LoadingPageText>;

  const props = {
    mappingType,
    events,
    selectedRow: state.selectedRow,
    errorMsg: state.errorMsg,
    isDataLoading: state.isDataLoading,
  };

  return (
    <div className="page-content-wrapper">
      <MUIDataTable title={settings.name} data={data.items} columns={settings.columns} options={settings.options} />
      {state.openSidePanel && <TeamMappingForm props={props} />}
    </div>
  );
}
